function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  "aria-hidden": "true",
  fill: "currentColor",
  height: "1em",
  width: "1em",
  viewBox: "64 64 896 896"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M239.825 534.975l409.8 400.525c19.75 19.325 51.825 19.325 71.575 0l47.8-46.7c19.75-19.3 19.75-50.55.075-69.875L444.325 500l324.75-318.925A48.675 48.675 0 00769 111.2l-47.8-46.7a51.45 51.45 0 00-71.575 0L239.825 465a48.675 48.675 0 000 69.95z"
}), /*#__PURE__*/React.createElement("path", {
  strokeLinecap: "round",
  strokeWidth: "40",
  stroke: "#000",
  d: "M170 720h230M170 820h230M170 920h230"
}), /*#__PURE__*/React.createElement("circle", {
  strokeWidth: "40",
  stroke: "#000",
  cx: "100",
  cy: "720",
  r: "15"
}), /*#__PURE__*/React.createElement("circle", {
  strokeWidth: "40",
  stroke: "#000",
  cx: "100",
  cy: "820",
  r: "15"
}), /*#__PURE__*/React.createElement("circle", {
  strokeWidth: "40",
  stroke: "#000",
  cx: "100",
  cy: "920",
  r: "15"
})));